import posthog, { type Properties } from 'posthog-js'

interface SignedInProps extends Properties {
  email: string
}

export const eventTracker = {
  signedIn: (data: SignedInProps) => {
    posthog.identify(data.email, data)
    posthog.capture('signedIn', data)
  },
  signUp: (data: Properties) => posthog.capture('signUp', data),
}
